import { Spacing } from '@billy/design-system'

import { PopoverBannerPosition } from '../types/popoverBannerPosition'

const bannerPositionOptions = {
  offset: `calc(100% + ${Spacing.S16})`,
  centeredX: `left: 50%; transform: translateX(-50%);`,
  centeredY: `top: 50%; transform: translateY(-50%);`,
}

export const getBannerPositionVariants = (): Record<PopoverBannerPosition, string> => {
  return {
    top: `
      bottom: ${bannerPositionOptions.offset};
      ${bannerPositionOptions.centeredX}
  `,
    bottom: `
      top: ${bannerPositionOptions.offset};
      ${bannerPositionOptions.centeredX}
  `,
    left: `
      right: ${bannerPositionOptions.offset};
      ${bannerPositionOptions.centeredY}
  `,
    right: `
      left: ${bannerPositionOptions.offset};
      ${bannerPositionOptions.centeredY}
  `,
  }
}
